import { FieldValues } from 'react-hook-form';
import { AssessmentsPage, AssessmentsQuestionViewModel } from '../types';
import { ASSESSMENTS_PAGE_SIZE } from '../constants';
import { checkIfQuestionIsAnswered } from './assessmentsQuestionUtils';

const shouldCountQuestionForProgress = (question: AssessmentsQuestionViewModel): boolean =>
  question.type !== 'label';

export const getAssessmentsPageCount = (questions: AssessmentsQuestionViewModel[]): number =>
  Math.ceil(questions.length / ASSESSMENTS_PAGE_SIZE);

export const generatePage = ({
  questions,
  formValues,
  skippedQuestionNumbers,
  pageNumber,
}: {
  questions: AssessmentsQuestionViewModel[];
  formValues: FieldValues;
  skippedQuestionNumbers: number[];
  pageNumber: number;
}) => {
  const progressQuestions = questions.filter(shouldCountQuestionForProgress);

  const questionsCompleted = progressQuestions.reduce((acc, question) => {
    const isSkipped = skippedQuestionNumbers.includes(question.questionNumber);
    if (isSkipped || checkIfQuestionIsAnswered(question, formValues)) {
      return acc + 1;
    }
    return acc;
  }, 0);

  return {
    pageNumber,
    questionCount: progressQuestions.length,
    questionsCompleted,
  };
};

export const generatePageList = ({
  questions,
  formValues,
  skippedQuestionNumbers,
}: {
  questions: AssessmentsQuestionViewModel[];
  formValues: FieldValues;
  skippedQuestionNumbers: number[];
}) => {
  const pagesCount = getAssessmentsPageCount(questions);
  const pagesArray: AssessmentsPage[] = [];
  for (let i = 0; i < pagesCount; i++) {
    // Get the questions for a single page based on the current index and page size
    const pageQuestions = questions.slice(
      i * ASSESSMENTS_PAGE_SIZE,
      (i + 1) * ASSESSMENTS_PAGE_SIZE,
    );

    const pageData = generatePage({
      questions: pageQuestions,
      formValues,
      skippedQuestionNumbers,
      pageNumber: i + 1,
    });

    pagesArray.push(pageData);
  }
  return pagesArray;
};

export const getPageOfQuestion = (questionNumber: number): number | null =>
  Math.floor((questionNumber - 1) / ASSESSMENTS_PAGE_SIZE) + 1;
